// Standalone entry (dev/direct load); importing bootloader triggers its self-mount. Hosts use ./AppMount.
import { prepareRuntime } from './appMount';

async function boot() {
  await prepareRuntime('boot');
  await import('./bootloader');
}

boot().catch((error) => console.error('[customers-ui] boot failed', error));
